export const uploadImageToServer = async (file: File): Promise<string> => {
  const uploadEndpoint = `${process.env.API_DOMAIN}/api/v1/upload/img/contact-us`; // 拼接完整接口地址

  const formData = new FormData();
  formData.append("photo", file);

  const response = await fetch(uploadEndpoint, {
    method: "POST",
    body: formData,
  });

  const result = await response.json().catch(() => ({}));

  // 业务错误：与 service/index 约定一致，code > 100000 为错误
  if (result.code != null && result.code > 100000) {
    throw new Error(result.message || "Upload failed");
  }
  if (!response.ok) {
    throw new Error(result.message || "Upload failed");
  }
  if (!result.data?.path) {
    throw new Error(result.message || "URL is missing from the returned results");
  }

  return result.data.path;
};